module.exports = __webpack_public_path__ + "static/fashion-section-base-33f240fcec38b674de6cdddbc3ab416b.png";